import { getGeolocation } from './getGeolocation'

export const getCountryCode = async () => {
  const country = await getGeolocation()
  return country.country_code || ''
}

// Values to match against Luma event regions (may be "CA" or "California").
export const getVisitorRegionCandidates = async () => {
  const geo = await getGeolocation()
  const candidates = [
    geo.region_code,
    geo.region_name,
    geo.region,
    geo.state_code,
    geo.state
  ]
  const seen = new Set()
  return candidates
    .map((value) => String(value || '').trim())
    .filter((value) => {
      if (!value) return false
      const key = value.toLowerCase()
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
}

export const getRegionFromGeolocation = async () => {
  const candidates = await getVisitorRegionCandidates()
  return candidates[0] || ''
}

export default getCountryCode
